import axios from 'axios';
import { LocalStorage, uid } from 'quasar';

export const initDeviceId = (state) => {
  if (LocalStorage.has('deviceId')) {
    state.deviceId = LocalStorage.getItem('deviceId');
  }
  else {
    state.deviceId = uid();
    LocalStorage.set('deviceId', state.deviceId);
  }
};

export const initAccount = (state) => {
  if (LocalStorage.has('access_token') && LocalStorage.has('account')) {
    axios.defaults.headers.common.Authorization = `Bearer ${LocalStorage.getItem('access_token')}`;
    state.access_token = LocalStorage.getItem('access_token');
    state.account = LocalStorage.getItem('account');
    state.isLoggedIn = true;
  }
};

export function updateUser(state, payload) {
  state.account = payload.account;
  LocalStorage.set('account', state.account);
}

export function updateLoggedIn(state, payload) {
  state.isLoggedIn = payload;
}

export function updateAccessToken(state, payload) {
  axios.defaults.headers.common.Authorization = `Bearer ${payload}`;
  state.access_token = payload;
  LocalStorage.set('access_token', payload);
}

export function logOut(state) {
  LocalStorage.remove('access_token');
  LocalStorage.remove('account');
  state.account = {};
  state.usersMessages = null;
  state.access_token = '';
  state.pushToken = '';
  state.isLoggedIn = false;
}

export function updatePushToken(state, payload) {
  state.pushToken = payload;
}

export function updateUsersMessages(state, payload) {
  state.usersMessages = payload;
}
